export default "__VITE_PUBLIC_ASSET__f9deb5ce__"